let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("bX0C0")).then(() => parcelRequire('3PxNF'));